import axios from 'axios';
import { StoreApi } from 'zustand';

import {
  getShopifyAxiosConfig,
  getShopifyGqlEndpoint,
  getShopifyUrlAndToken,
} from '../../shopify';
import { CustomerStore } from './useCustomer';

const query = `
mutation customerAccessTokenDelete(
  $customerAccessToken: String!
) {
  customerAccessTokenDelete(customerAccessToken: $customerAccessToken) {
    deletedAccessToken
    deletedCustomerAccessTokenId
    userErrors {
      field
      message
    }
  }
}`;

export function logout(
  set: StoreApi<CustomerStore>['setState'],
  get: StoreApi<CustomerStore>['getState'],
): () => Promise<void> {
  return async () => {
    try {
      const { token } = getShopifyUrlAndToken();
      const customerAccessToken = get()?.customerAccessToken?.accessToken;
      if (customerAccessToken) {
        await axios.post(
          getShopifyGqlEndpoint(),
          {
            query,
            variables: {
              customerAccessToken,
            },
          },
          getShopifyAxiosConfig(token),
        );
      }
      set({
        customer: undefined,
        customerAccessToken: undefined,
        customerLoginError: undefined,
        customerResetPasswordError: undefined,
        currentProDiscount: undefined,
      });
    } catch (err) {
      console.error(err);
    }
  };
}
